import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import { AreaChart, ChartYHanle } from './common';

export class OutputChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "生产";
        this.unit = "数量";
        this.yName = "生产[x1000支]";
        this.yHanle = ChartYHanle.numerical;
    }

    getMarkData() {
        return { handle: "last" };
    }
}

export class LastOutputChart extends AreaChart {

    constructor(props) {
        super(props);
        this.title = "生产";
        this.unit = "数量";
        this.yName = "生产[x1000支]";
        this.yHanle = ChartYHanle.numerical;
    }

    getX() {
        return [15, 30, 45, 60];
    }
}
